<template>
  <div class="details">
    <titleBar :title="title"></titleBar>
    <div class="details_content">
      <div class="details_bgimg" v-if="data.imgList" @click="closeModal">
        <img v-for="(item , index) in data.imgList" :key="index" :src="item" />
      </div>
      <div class="details_bottom">
        <template v-if="btn_status">
          <div class="details_bottom_left" @click="showModal">
            <div class="details_money">
              <span class="details_money_nofree">
                <div class="logo">¥</div>
                {{transMoney(current.salePrice)}}
              </span>
            </div>
            <div class="details_info">
              <div class="time">
                <span>{{tranferTime(current.startTime)}}-{{tranferTime(current.endTime)}}</span>
                <span class="arrow" v-if="!data.isBuy" :class="{up: isShow}"></span>
              </div>
              <div class="origin_price">¥{{transMoney(current.originalPrice)}}</div>
            </div>
          </div>
          <div class="details_bottom_right">
            <span v-if="!data.isBuy && current.orderNumber==0" @click="pay_click">立即提升</span>
            <span v-else-if="!data.isBuy && current.orderNumber!=0" @click="pay_click">去支付</span>
            <span v-else @click="show_method">已购买</span>
          </div>
        </template>
      </div>
      <div></div>
      <div class="details_modal" :class="{'active': isShow}" ref="modal" @click.stop>
        <div class="details_modal_title">
          <div style="padding-bottom: 0.4rem;" class="details_modal_title_top">选择课程</div>
        </div>
        <div class="details_modal_item" ref="list_item">
          <div>
            <div
              class="details_modal_item_main"
              @click="selectTeacher($index)"
              :class="{activity: $index==index}"
              v-for="(el,$index) in data.summerCourseList"
              :key="$index"
            >
              <template>
                <div class="itemWrap">
                  <div class="time">{{tranferTime(el.startTime)}}-{{tranferTime(el.endTime)}}</div>
                  <div class="info">
                    <span>{{el.teacherName}}</span>
                    <img :src="el.teacherPhoto" />
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="tips" class="mark" @click="close_tips" @touchmove.prevent>
      <div class="tips_bottom" @click.stop>
        <div v-if="tips == 'method'" class="method">
          <h2>上课方式</h2>
          <p>
            1.电脑：浏览器打开官网
            <span @click="copy_event">复制网址</span>
          </p>
          <p>2.手机/pad：应用市场内下载小象辅导APP</p>
          <p>
            3.如有疑问可咨询人工客服
            <span>
              <a @click="call_event">拨打电话</a>
            </span>
          </p>
          <p>记得使用家长盒子的注册手机号登录哦～</p>
        </div>
      </div>
    </div>
    <p v-if="toast" class="toast">{{toast}}</p>
    <lesson_loading v-if="loadingLock" :status="status"></lesson_loading>
  </div>
</template>

<script>
import ajax from "@/api/lightAjax.js";
import utils from "@/assets/js/utils";
import titleBar from "@/components/common/titleBar.vue";
import lesson_loading from "@/components/common/lesson_loading.vue";
import BSroll from "better-scroll";
const payHost = {
  test: "https://qa2-mvip.knowbox.cn",
  preview: "https://beta-mvip.knowbox.cn",
  production: "https://mvip.knowbox.cn"
};
let vm = null;
window.callback = function(obj) {
  vm.creatOrder(JSON.parse(obj));
};
export default {
  name: "",
  data() {
    return {
      title: "活动详情",
      index: 0,
      state: 1,
      money: 1,
      isFree: false,
      people: 130,
      data: {
        imgList: [],
        summerCourseList: []
      },
      product_arr: [],
      productList: [],
      btn_status: true,
      loadingLock: true,
      status: "loading",
      orderId: 0,
      price: 0,
      token: "",
      activityNumber: "",
      version: "",
      source: "",
      isShow: false,
      mix_price: false,
      tips: "",
      order_btn: true,
      toast: "",
      select_price: 0,
      current: {}
    };
  },
  components: {
    titleBar,
    lesson_loading
  },
  watch: {
    // product_arr (curVal,oldVal){
    //   console.log(curVal);
    //   let self = this
    //   self.productList = []
    //   for(let i = 0; i < curVal.length; i++ ){
    //     let arr = {
    //       productID : curVal[i],
    //       num : 1,
    //     }
    //     self.productList.push(arr)
    //   }
    // },
    toast(newName, oldName) {
      let self = this;
      if (newName != "") {
        setTimeout(function() {
          self.toast = "";
        }, 2000);
      }
    }
  },
  methods: {
    transMoney: function(cashNum) {
      return (parseInt(cashNum) / 100).toFixed(2);
    },
    showModal() {
      if (this.data.isBuy != 0) return;
      this.isShow = !this.isShow;
      // this.$refs.modal.style.bottom = "-6.06rem"
      // this.$refs.modal.style.transform = "translateY(-6.94rem)"
      // this.$refs.modal.style.transition = "transform .5s ease-in-out"
    },
    close_tips() {
      this.tips = "";
    },
    closeModal() {
      this.isShow = false;
      // this.$refs.modal.style.transform = "translateY(6.06rem)"
      // this.$refs.modal.style.transition = "transform .6s ease-in-out"
    },
    selectTeacher: function(index) {
      let self = this;
      self.current = self.data.summerCourseList[index];
      self.index = index;
    },
    initData: async function() {
      let self = this;
      const [resp] = await ajax.all([
        ajax.get("/light/live-introduce/summer-course-sale-page", {
          params: {
            token: self.token,
            grade: self.grade,
            teacherNumber: self.teacherNumber
          }
        })
      ]);

      if (resp.data.code == 99999) {
        utils.sendLog(
          {
            token: self.token,
            version: self.version,
            source: self.source,
            extensionJson: {
              courseID: self.courseId
            }
          },
          "hzxx688"
        );
        this.data = resp.data.data;
        this.data.orderState = 2;
        for (let i = 0; i < self.data.summerCourseList.length; i++) {
          let orderId = self.data.summerCourseList[i].orderId;
          if (self.data.summerCourseList[i].selected) {
            self.index = i;
            self.current = self.data.summerCourseList[i];
          }
          if (orderId != 0 && !self.orderId) {
            self.orderId = orderId;
          }
        }
        this.loadingLock = false;
        if (self.data.summerCourseList.length) {
          this.loadingLock = false;
        } else {
          this.status = "empty";
        }
        self.$nextTick(function() {
          self.scroll = new BSroll(self.$refs.list_item, {
            click: true
          });
        });
      } else {
        this.loadingLock = true;
        this.status = "error";
      }
    },
    pay_click: function() {
      let self = this;
      if (JSON.stringify(self.current) == "{}") {
        return (this.toast = "请选择购买的课程");
      }
      utils.sendLog(
        {
          token: self.token,
          version: "3.3.0",
          source: "h5",
          extensionJson: {
            courseID: self.courseId
          }
        },
        "hzxx689"
      );
      this.order_btn = false;
      console.log(self.current.orderNumber);
      if (self.current.orderNumber == 0) {
        window.location.href = `${
          payHost[process.env.VUE_APP_INTER]
        }/ClassBuy?token=${self.token}&source=LightLesson&classNumber=${
          self.current.classNumber
        }&activityNumber=0&tureclassNumber=${
          self.current.classNumber
        }&miniClassNumber=0&channel=i_xhjz&type=21`;
      } else {
        window.location.href = `${
          payHost[process.env.VUE_APP_INTER]
        }/SettlementCenter?token=${self.token}&source=LightLesson&orderNumber=${
          self.current.orderNumber
        }&classNumber=${
          self.current.orderNumber
        }&activityNumber=0&tureclassNumber=${
          self.current.orderNumber
        }&miniClassNumber=0&channel=i_xhjz&type=21`;
      }
    },
    copy_event: function() {
      window.location = "hybird://method/copy2Clipboard?content=vip.knowbox.cn";
    },
    call_event() {
      window.location =
        "hybird://method/openBrowser?url=" + decodeURI("tel://400-010-0180");
    },
    show_method() {
      this.tips = "method";
    },
    tranferTime: function(timestamp) {
      var time = new Date(timestamp * 1000);
      return time.getMonth() + 1 + "月" + time.getDay() + "日";
    }
  },
  created: function() {
    let self = this;
    vm = this;
    self.token = utils.getQueryString("token");
    self.grade = utils.getQueryString("grade");
    self.teacherNumber = utils.getQueryString("teacherNumber");
    self.version = utils.getQueryString("version");
    self.activityNumber = utils.getQueryString("activityNumber");
    self.source = utils.getQueryString("source");
    self.courseId = utils.getQueryString("courseId");
    self.initData();
  }
};
</script>

<style lang="scss">
@font-face {
  font-family: "BebasNeueBold";
  src: url("https://appd.knowbox.cn/ss/v310/BebasNeueBold.ttf");
}
.details_bottom {
  position: fixed;
  z-index: 100;
  bottom: 0;
  width: 100%;
  height: 1.1rem;
  background-color: #f5833d;
  z-index: 101;
  border-top: 1px solid #f0eff1;
  p {
    text-align: center;
    font-family: PingFangSC-Medium;
    font-size: 0.38rem;
    line-height: 1.1rem;
    color: #ffffff;
  }
}
.details_bottom_left {
  float: left;
  height: 1.1rem;
  width: 70%;
  text-align: center;
  line-height: 0.88rem;
  background-color: #fff;
  display: flex;
}
.details_money {
  box-sizing: border-box;
  padding-left: 0.4rem;
  display: flex;
  align-items: center;
}
.details_info {
  flex: 1;
  flex-direction: column;
  text-align: left;
  padding: 0.24rem 0 0.24rem 0.2rem;
  .time {
    font-family: "PingFangSC-Semibold";
    font-size: 0.26rem;
    color: #919294;
    line-height: 0.26rem;
    .arrow {
      width: 0.18rem;
      height: 0.14rem;
      display: inline-block;
      background: url("../../assets/images/light_lesson/arrow_down.png") 0 0 /
        cover no-repeat;
      margin-bottom: 0.04rem;
      margin-left: 0.1rem;
      transition: all 300ms linear;
    }
    .arrow.up {
      transform: rotate(-180deg);
    }
  }

  .origin_price {
    font-family: "BebasNeueBold";
    font-size: 0.22rem;
    line-height: 0.22rem;
    color: #bec0c2;
    margin-top: 0.12rem;
    text-decoration: line-through;
  }
}
.details_money_free {
  color: #ff714c;
  font-size: 0.36rem;
}
.details_money_nofree {
  color: rgb(253, 96, 96);
  font-size: 0.72rem;
  height: 0.72rem;
  font-family: "BebasNeueBold";
  position: relative;
  padding-left: 0.3rem;
  div.logo {
    position: absolute;
    left: 0;
    top: 0.02rem;
    font-size: 0.4rem;
    width: 0.4rem;
    height: 0.72rem;
    overflow: hidden;
    text-align: center;
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
    justify-content: flex-end;
  }
}
/*.details_money_nofree span {*/
/*color: #ff714c;*/
/*font-size: 0.24rem;*/
/*font-weight: 100;*/
/*font-family: PingFangSC-Medium;*/
/*}*/
.details_people {
  font-size: 0.24rem;
  padding-right: 0.7rem;
  line-height: 0.25rem;
  padding-top: 0.48rem;
  float: right;
  color: #9796a4;
  font-family: PingFangSC-Medium;
}
.details_bottom_right {
  text-align: center;
  width: 30%;
  float: right;
  line-height: 1.1rem;
  color: #ffffff;
  background-color: rgb(253, 96, 96);
  font-size: 0.36rem;
  font-family: PingFangSC-Medium;
  text-shadow: 0 0.04rem 0.04em #ff3b3b;
}
.details_bottom_tips {
  position: fixed;
  bottom: 1.1rem;
  width: 100%;
  height: 0.6rem;
  font-family: PingFangSC-Medium;
  font-size: 0.26rem;
  line-height: 0.6rem;
  color: #ffffff;
  background-color: #000000;
  opacity: 0.7;
  text-align: center;
  z-index: 999;
}
.details_shadow {
  position: fixed;
  z-index: 99;
  opacity: 0.3;
  width: 100%;
  height: 100%;
  background-color: #000;
}
.details_bgimg {
  margin-top: 0.88rem;
  margin-bottom: 1.1rem;
  img {
    width: 100%;
  }
}
.details_modal {
  position: fixed;
  bottom: -6.06rem;
  z-index: 100;
  width: 100%;
  height: 5.06rem;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  background-color: #fff;
  box-sizing: border-box;
  padding: 0.22rem 0.5rem 0;
  &_title {
    color: #56586a;
    &_top {
      font-family: PingFangSC-Medium;
      font-weight: 900;
      font-size: 0.32rem;
      color: #919294;
      display: block;
      width: 1.8rem;
      margin: 0 auto;
      text-align: center;
      position: relative;
    }
    &_top::before {
      content: "";
      display: table;
      width: 4px;
      height: 2px;
      border-radius: 0.01rem;
      background-color: #e2e2e2;
      position: absolute;
      top: 12px;
      left: 0;
    }
    &_top::after {
      content: "";
      display: table;
      width: 4px;
      height: 2px;
      border-radius: 1px;
      background-color: #e2e2e2;
      position: absolute;
      top: 10px;
      right: 0;
    }
    &_middle {
      margin-bottom: 0.18rem;
      font-family: PingFangSC-Regular;
      font-size: 0.26rem;
      span {
        padding-right: 0.3rem;
      }
    }
  }
  &_item {
    padding-top: 0.5rem;
    padding-bottom: 0.2rem;
    height: 3.8rem;
    overflow-y: scroll;
    &_main {
      position: relative;
      padding-left: 0.52rem;
      margin-bottom: 0.3rem;
      box-sizing: border-box;
      width: 100%;
      height: 0.98rem;
      background: #fafafa;
      font-size: 0.2rem;
      position: relative;
      border-radius: 0.5rem;
      display: flex;
      .itemWrap {
        display: flex;
        flex: 1;
        align-items: center;
      }
      .time {
        flex: 1;
        font-size: 14px;
        color: #4a4b4c;
        font-family: PingFangSC-Medium;
      }
      .info {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        padding-right: 0.1rem;
        span {
          font-family: PingFangSC-Medium;
          font-size: 0.28rem;
          color: #919294;
          padding-right: 0.28rem;
          align-items: center;
          display: flex;
        }
        img {
          width: 0.78rem;
          height: 0.78rem;
          /*border: 1px solid #e4ebf0;*/
          border-radius: 50%;
        }
      }

      /*&:after {*/
      /*content: "";*/
      /*position: absolute;*/
      /*bottom: 0;*/
      /*left: 0;*/
      /*width: 100%;*/
      /*height: 1px;*/
      /*background: #eeeeee;*/
      /*transform: scaleY(0.5);*/
      /*}*/
      &_header {
        float: left;
        margin: 0.1rem 0.2rem 0.1rem 0.1rem;
        width: 0.6rem;
        height: 0.6rem;
        background: pink;
        border-radius: 50%;
      }
      &_detail {
        position: relative;
        height: 100%;
        &_time {
          font-family: PingFangSC-Regular;
          font-size: 0.26rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          padding-bottom: 0.2rem;
          color: #9796a4;
        }
        &_other {
          font-family: PingFangSC-Regular;
          font-size: 0.24rem;
          color: #56546c;
          height: 0.2rem;
          line-height: 0.2rem;
          span {
            font-family: PingFangSC-Medium;
            margin-right: 0.2rem;
          }
          &_1 {
            font-size: 0.2rem;
            margin-right: 0.2rem;
            font-weight: normal;
            background-color: #eaebf1;
            padding: 0 0.1rem;
            border-radius: 0.2rem;
            color: #9ea2b7;
            -webkit-text-size-adjust: none;
          }
          &_2 {
            font-size: 0.2rem;
            margin-right: 0.2rem;
            font-weight: normal;
            background-color: #eaebf1;
            padding: 0 0.1rem;
            border-radius: 0.2rem;
            color: #b48051;
            -webkit-text-size-adjust: none;
          }
        }
      }
      &_radio {
        display: block;
        position: absolute;
        right: 0.57rem;
        bottom: 0.2rem;
        height: 0.36rem;
        font-family: PingFangSC-Medium;
        font-size: 0.32rem;
        color: #ff714c;
        line-height: 0.36rem;
      }
      input[type="checkbox"] {
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 100;
        opacity: 0;
        top: 0;
      }
      input:checked + label {
        // background-color: #fe6d32;
        border: 1px solid #9ea2b7;
      }
      input:checked + label::after {
        position: absolute;
        content: "";
        width: 0.16rem;
        height: 0.16rem;
        top: 0.08rem;
        left: 0.08rem;
        background-color: #9ea2b7;
        border-radius: 100%;
      }
      label {
        position: absolute;
        right: 0;
        bottom: 0.2rem;
        width: 0.36rem;
        height: 0.36rem;
        border-radius: 50%;
        border: 1px solid #999;
      }
      input:checked + label::after {
        position: absolute;
        content: "";
        width: 0.16rem;
        height: 0.16rem;
        top: 0.08rem;
        left: 0.08rem;
        background-color: #9ea2b7;
        border-radius: 100%;
      }
      .no_check {
        opacity: 0.5;
      }
    }
    &_main.activity {
      background: #ffecec;
      border: 2px solid #fd6060;
      .time,
      .info span {
        color: #fd6060;
      }
    }
  }
}
.details_modal.active {
  bottom: -6.06rem;
  transform: translateY(-6.94rem);
  transition: transform 0.5s ease-in-out;
}
.mark {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 99;
  background-color: rgba(0, 0, 0, 0.7);
  .tips_middle {
    position: absolute;
    padding: 0.5rem 0.4rem;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 5.8rem;
    height: 3.65rem;
    background-color: #fff;
    border-radius: 0.3rem;
    text-align: center;
    font-family: PingFangSC-Medium;
    h3 {
      font-size: 0.36rem;
      color: #56586a;
    }
    p {
      margin-top: 0.32rem;
      font-size: 0.26rem;
      line-height: 0.39rem;
      color: #8487a0;
    }
    .btn {
      margin-top: 0.2rem;
      overflow: hidden;
      span {
        display: inline-block;
        width: 2.35rem;
        height: 0.89rem;
        line-height: 0.89rem;
        font-size: 0.32rem;
        border-radius: 0.44rem;
        &:first-child {
          float: left;
          color: #e7be84;
          border: solid 1px #e7be84;
        }
        &:last-child {
          float: right;
          color: #fff;
          background-color: #e7be84;
          border: solid 1px #e7be84;
        }
      }
    }
  }
  .tips_bottom {
    position: absolute;
    padding: 0.6rem 0.5rem 0;
    bottom: 0;
    width: 100%;
    height: 5rem;
    background: #fff;
    border-radius: 0.34rem 0.34rem 0 0;
    font-family: PingFangSC-Medium;
    .announce_item {
      height: 2.1rem;
      overflow: hidden;
      h3 {
        font-size: 0.28rem;
        line-height: 0.42rem;
        color: #9796a4;
      }
    }
    p {
      margin-top: 0.1rem;
      height: 0.46rem;
      line-height: 0.46rem;
      font-size: 0.26rem;
      color: #9796a4;
      span {
        float: right;
        display: inline-block;
        width: 1.3rem;
        height: 0.46rem;
        background-color: #e7be85;
        border-radius: 0.23rem;
        font-size: 0.22rem;
        color: #fff;
        text-align: center;
        a {
          color: #fff;
        }
      }
      &:last-child {
        &:before {
          content: "";
          display: inline-block;
          width: 0.08rem;
          height: 0.08rem;
          border-radius: 50%;
          background-color: #f5833d;
          margin: 0 0.1rem 0.06rem 0.03rem;
        }
        font-family: PingFangSC-Regular;
        font-size: 0.26rem;
        color: #f5833d;
      }
    }
  }
  h2 {
    margin-bottom: 0.4rem;
    font-size: 0.38rem;
    line-height: 0.46rem;
    color: #56586a;
  }
}
.toast {
  position: fixed;
  width: 3rem;
  height: 1.5rem;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 8px;
  font-family: PingFangSC-Medium;
  font-size: 0.3rem;
  line-height: 1.5rem;
  text-align: center;
  color: #fff;
  z-index: 999;
}
</style>
